module.exports = __webpack_public_path__ + "2-46.jpg?5cba85de0b3988589b14b6081fce4d5f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-46.jpg
// module id = 123
// module chunks = 0